import React, { Component } from 'react';
import { Icon } from 'legacy-packages/ft-cb';
import { viewed } from '../shared/status';

import './relative_link.scss';

class Player extends Component {
  render() {
    const { text, href, icon, iconOptions = {} } = this.props.item.content;
    const to = `${FYM_FRONTEND_URL}/${href}`;
    return (
      <div className="relative_link_wrapper">
        {icon && <Icon name={icon} {...iconOptions} />}
        <a href={to}>{text}</a>
      </div>
    );
  }
}

Player.displayName = 'RelativeLink';

export default { Player, status: viewed };
